import React, { useEffect, useMemo, useState } from 'react';
import { exportExcel } from '../../../../utils/exportExcel';
import { useColumns } from '../../utils/columns';
import { useParticipantes } from '../../hooks/useParticipantes';
import { enumTipoParticipanteConValores, StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import MandatarioForm from './mandatarioForm';
import { EliminarMandatarioDto, Mandatario } from '../../models/mandatario';
import { Conyuge } from '../../models/conyuge';
import ConyugeForm from './conyugeForm';
import { Deudor } from '../../models/deudor';
import DeudorForm from './deudorForm';
import CodeudorForm from './codeudorForm';
import { Codeudor } from '../../models/codeudor';
import { EliminarParticipante, Participante, ParticipanteRequest } from '../../models/participantes';
import { useDeudor } from '../../hooks/useDeudor';
import { DeudorJuridico } from '../../models/deudorJuridico';
import DeudorJuridicoForm from './deudorJuridicoForm';
import { useMandatarios } from '../../hooks/useMandatarios';
import { useToast } from '../../../../hooks/useToast';
import { useCodeudor } from '../../hooks/useCodeudor';
import { useConyuge } from '../../hooks/useConyuge';
import Tabla from '../../../../components/ui/materialui/tabla';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import SummarizeTwoToneIcon from '@mui/icons-material/SummarizeTwoTone';
import { Button, Grid2, Menu, MenuItem } from '@mui/material';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { format } from 'rut.js';
import { copyParticipantes } from '../../services/servicesParticipantes';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface FormProps {
    idMutuo: number;
    participantesRef: React.MutableRefObject<HTMLInputElement | null>;
    esMutuoNormalyConComplementario: boolean;
    isComplementario: boolean;
    idSolicitud: string | undefined;
    isDesactivado: boolean;
    esVigente?: boolean;
}

const ListaParticipantes: React.FC<FormProps> = (props) => {
    const { listaEstadoCivil, getParticipantes, ciudades,
        listaParticipantes, ciudadesSelect, estadoCivilSelect, beneficiosSii, beneficioSiiSelect
    } = useParticipantes();

    const { eliminarMandario } = useMandatarios();
    const { eliminarCodeudor } = useCodeudor();
    const { eliminarConyuge } = useConyuge();
    const [rolParticipanteSeleccionado, setRolParticipanteSeleccionado] =
        useState<enumTipoParticipanteConValores>();
    const [primerLlamadoApi, setPrimerLlamadoApi] = useState<boolean>(true);
    const [dataDeudor, setDataDeudor] = useState<Deudor>();
    const [dataDeudorJuridico, setDataDeudorJuridico] = useState<DeudorJuridico>();
    const [dataCodeudor, setDataCodeudor] = useState<Codeudor>();
    const [dataMandatario, setDataMandatario] = useState<Mandatario>();
    const [dataConyuge, setDataConyuge] = useState<Conyuge>();
    const [esJuridicio, setEsJuridico] = useState<boolean>(false);
    const [esConyuge, setEsConyuge] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [showParticipantes, setShowParticipantes] = useState<boolean>(true);
    const [participanteNuevo, setParticipanteNuevo] = useState<boolean>(false);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    const { addToast } = useToast();

    const handleCopy = () => {
        setModalConfirmacion({
            show: true,
            title: "Generar Copia",
            message: '¿Desea copiar la información de la operación desde el mutuo normal?',
            metodo: () => {
                onCopy()
            },
        });
    }

    const onCopy = async () => {
        if (props.idSolicitud != null) {
            const resp = await copyParticipantes(props.idSolicitud);
            if (resp.status === StatusCode.NoContent || resp.status === StatusCode.Ok) {
                addToast({
                    mostrar: true,
                    titulo: 'Confirmación',
                    tipo: 'Success',
                    mensaje: 'Datos copiados correctamente'
                });

                renderizar();
            }
        }
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = async (dataDelete: EliminarParticipante) => {
        let message: string = '';
        dataDelete.rut = format(dataDelete.rut, { dots: false });

        switch (dataDelete.idTipoParticipante) {

            case enumTipoParticipanteConValores.Mandatario:
                {
                    message = `¿Estás seguro de que deseas eliminar al mandatario ${dataDelete.nombre}?`;
                    const data: EliminarMandatarioDto = {
                        idMutuo: props.idMutuo,
                        rut: dataDelete.rut
                    }

                    setModalConfirmacion({
                        show: true,
                        title: "Confirmar eliminación",
                        message: message,
                        metodo: async () => {

                            const resp = await eliminarMandario(data);

                            if (resp.status === StatusCode.NoContent) {
                                addToast({
                                    mostrar: true,
                                    titulo: 'Confirmación',
                                    tipo: 'Success',
                                    mensaje: 'Mandatario eliminado correctamente'
                                });
                                renderizar();
                                volver();

                            }
                        },
                    });
                }

                break;

            case enumTipoParticipanteConValores.Codeudor:
                {
                    message = `¿Estás seguro de que deseas eliminar al codeudor ${dataDelete.nombre}?`;
                    const data: ParticipanteRequest = {
                        codigoTipoParticipante: enumTipoParticipanteConValores.Codeudor,
                        mutuoId: props.idMutuo,
                        rut: dataDelete.rut
                    }

                    setModalConfirmacion({
                        show: true,
                        title: "Confirmar eliminación",
                        message: message,
                        metodo: async () => {
                            const resp = await eliminarCodeudor(data);

                            if (resp?.status === StatusCode.NoContent) {
                                addToast({
                                    mostrar: true,
                                    titulo: 'Confirmación',
                                    tipo: 'Success',
                                    mensaje: 'Codeudor eliminado correctamente'
                                });
                                renderizar();
                                volver();
                            }
                        },
                    });
                }

                break;

            case enumTipoParticipanteConValores.Conyuge:
                {
                    message = `¿Estás seguro de que deseas eliminar al cónyuge ${dataDelete.nombre}?`;
                    const data: ParticipanteRequest = {
                        codigoTipoParticipante: enumTipoParticipanteConValores.Conyuge,
                        mutuoId: props.idMutuo,
                        rut: dataDelete.rut
                    }

                    setModalConfirmacion({
                        show: true,
                        title: "Confirmar eliminación",
                        message: message,
                        metodo: async () => {
                            const resp = await eliminarConyuge(data)
                            if (resp.status === StatusCode.NoContent) {
                                addToast({
                                    mostrar: true,
                                    titulo: 'Confirmación',
                                    tipo: 'Success',
                                    mensaje: 'Cónyuge eliminado correctamente'
                                });
                                renderizar();
                                volver();
                            }
                        },
                    });
                }

                break;

            default:
                console.log('Tipo de participante no reconocido')
        }
    }

    const { COLUMNS } = useColumns(setRolParticipanteSeleccionado, setDataMandatario,
        setDataConyuge, setDataDeudor, setDataDeudorJuridico, setDataCodeudor, setShowParticipantes, setModalConfirmacion, handleDelete, props.isComplementario, props.isDesactivado, props.esVigente);
    const columns = useMemo(() => COLUMNS, [listaParticipantes, props.esVigente]);
    const { obtenerDeudor, obtenerDeudorJuridico } = useDeudor();
    const scrollToTopForm = () => {
        if (props.participantesRef.current) {
            const { top } = props.participantesRef.current.getBoundingClientRect();
            window.scrollTo({
                top: window.scrollY + top + 50,
                behavior: 'smooth',
            });
        }
    };

    useEffect(() => {
        getParticipantes(props.idMutuo);
        ciudades();
        listaEstadoCivil();
        beneficiosSii();

        scrollToTopForm();

    }, [props.idMutuo]);

    const renderizar = () => {
        getParticipantes(props.idMutuo);
    }

    const botonesConstantes = [
        {
            id: enumTipoParticipanteConValores.Codeudor,
            valor: 'Codeudor',
            accion: () => seleccionarRolNuevo(enumTipoParticipanteConValores.Codeudor)
        },
        {
            id: enumTipoParticipanteConValores.Mandatario,
            valor: 'Mandatario',
            accion: () => { seleccionarRolNuevo(enumTipoParticipanteConValores.Mandatario) }
        },
        {
            id: enumTipoParticipanteConValores.Conyuge,
            valor: 'Cónyuge',
            accion: () => { seleccionarRolNuevo(enumTipoParticipanteConValores.Conyuge) }
        }
    ]

    const [botonesMenu, setBotonesMenu] = useState(botonesConstantes);

    const seleccionarRolNuevo = (rol: enumTipoParticipanteConValores) => {
        setRolParticipanteSeleccionado(rol);
        setParticipanteNuevo(true)
        setShowParticipantes(false);
    }

    const volver = () => {
        setShowParticipantes(true);
        setParticipanteNuevo(false);
        setDataDeudor(undefined)
        setDataCodeudor(undefined);
        setDataConyuge(undefined);
        setDataMandatario(undefined);
        setDataDeudorJuridico(undefined);
    }

    useEffect(() => {

        if (listaParticipantes.length > 0 && primerLlamadoApi) {

            let participanteDeudor: Participante =
                listaParticipantes?.find(x => x.idTipoParticipante === enumTipoParticipanteConValores.Deudor ||
                    x.idTipoParticipante === enumTipoParticipanteConValores.DeudorJuridico)!;

            let data: ParticipanteRequest = {
                codigoTipoParticipante: participanteDeudor.idTipoParticipante,
                rut: participanteDeudor.rut ?? '',
                mutuoId: props.idMutuo
            }

            if (participanteDeudor.idTipoParticipante === enumTipoParticipanteConValores.Deudor) {
                const datosDeudor: Promise<Deudor | void> = obtenerDeudor(data);
                datosDeudor.then((value: Deudor | void) => {
                    if (!value) return;
                    setDataDeudor(value);
                    setRolParticipanteSeleccionado(enumTipoParticipanteConValores.Deudor)
                });
            }

            if (participanteDeudor.idTipoParticipante === enumTipoParticipanteConValores.DeudorJuridico) {
                const datosDeudorJuridico: Promise<DeudorJuridico | void> = obtenerDeudorJuridico(data);
                datosDeudorJuridico.then((value: DeudorJuridico | void) => {
                    if (!value) return;
                    setDataDeudorJuridico(value);
                    setRolParticipanteSeleccionado(enumTipoParticipanteConValores.DeudorJuridico)
                });
            }

            setPrimerLlamadoApi(false);
        }

        if (listaParticipantes.length > 0) {
            const existeConyuge = listaParticipantes.some(participante =>
                participante.idTipoParticipante === enumTipoParticipanteConValores.Conyuge ||
                (participante.idTipoParticipante === enumTipoParticipanteConValores.Codeudor && participante.conyuge === "SI")
            );

            const esSolteroViudoDivor = listaParticipantes.some(participante => (participante.idTipoParticipante === enumTipoParticipanteConValores.Deudor &&
                (participante.estadoCivil === 'Soltero' || participante.estadoCivil === 'Viudo' || participante.estadoCivil === 'Divorciado')));

            const esJuridico = listaParticipantes.some(x => x.idTipoParticipante === enumTipoParticipanteConValores.DeudorJuridico)

            const botonesFiltrados = (existeConyuge || esSolteroViudoDivor || esJuridico)
                ? botonesConstantes.filter(boton => boton.id !== enumTipoParticipanteConValores.Conyuge)
                : botonesConstantes;

            setBotonesMenu(botonesFiltrados);

            setEsJuridico(esJuridico);
        }

    }, [listaParticipantes]);

    useEffect(() => {

        const tieneConyuge = listaParticipantes.some(x => x.conyuge === "SI");
        const esSolteroViudoDivor = listaParticipantes.some(x => x.idTipoParticipante === enumTipoParticipanteConValores.Deudor &&
            (x.estadoCivil === 'Soltero' || x.estadoCivil === 'Viudo' || x.estadoCivil === 'Divorciado'));

        if (esSolteroViudoDivor) {
            setEsConyuge(true);
        }
        else if (tieneConyuge && participanteNuevo) {
            setEsConyuge(true)
        } else if (tieneConyuge) {
            setEsConyuge(!listaParticipantes.some(x => x.rut === dataCodeudor?.rut && x.conyuge === "SI"))
        } else {
            setEsConyuge(false);
        }

    }, [dataCodeudor, participanteNuevo])

    return (
        <>
            {showParticipantes &&
                <Grid2>
                    <Tabla
                        columns={columns}
                        data={listaParticipantes}
                        titulo={<TableHeader
                            // title="Listado participantes"
                            buttonExport={
                                <>
                                <PermissionGuard permissions={[TipoFuncionalidad.Transversal_exportar]}>
                                    <MButton
                                        type="button"
                                        variant="outlined"
                                        startIcon={<SummarizeTwoToneIcon />}
                                        onClick={() => exportExcel(listaParticipantes, columns, "Listado-Participantes")}
                                    >
                                        Exportar
                                    </MButton>
                                    </PermissionGuard>
                                </>
                            }
                            button={
                                <>
                                    {
                                        botonesMenu.length > 0 &&
                                        <>
                                            <DetalleMutuoPermissionGuard esVigente={props.esVigente} permissions={[TipoFuncionalidad.Bandeja_editar]}>
                                                {!props.isComplementario ? (
                                                    <Button
                                                        disabled={props.isDesactivado}
                                                        variant="contained" onClick={handleClick}>
                                                        Agregar
                                                    </Button>
                                                ) : (
                                                    <Button variant="contained" onClick={handleCopy}>
                                                        Copiar Desde Mutuo Normal
                                                    </Button>
                                                )}
                                                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                                                    {botonesMenu.map((boton, index) => (
                                                        <MenuItem key={index} onClick={() => { boton.accion(); handleClose(); }}>
                                                            {boton.valor}
                                                        </MenuItem>
                                                    ))}
                                                </Menu>
                                            </DetalleMutuoPermissionGuard>
                                        </>
                                    }
                                </>

                            }
                        />}
                    />
                </Grid2>
            }

            {
                (rolParticipanteSeleccionado === enumTipoParticipanteConValores.Deudor) &&
                (dataDeudor) && !showParticipantes &&

                <Grid2>
                    <DeudorForm dataDeudor={dataDeudor}
                        ciudadesSelect={ciudadesSelect}
                        estadoCivilSelect={estadoCivilSelect}
                        beneficioSiiSelect={beneficioSiiSelect}
                        idMutuo={props.idMutuo}
                        setShowParticipantes={setShowParticipantes}
                        renderizar={renderizar}
                        volver={volver}
                        esMutuoNormalyConComplementario={props.esMutuoNormalyConComplementario}
                        isComplementario={props.isComplementario}
                        isDesactivado={props.isDesactivado}
                        esVigente={props.esVigente}
                    ></DeudorForm>
                </Grid2>
            }

            {
                (rolParticipanteSeleccionado === enumTipoParticipanteConValores.DeudorJuridico) &&
                (dataDeudorJuridico) && !showParticipantes &&

                <Grid2>
                    <DeudorJuridicoForm dataDeudorJuridico={dataDeudorJuridico}
                        ciudadesSelect={ciudadesSelect}
                        idMutuo={props.idMutuo}
                        setShowParticipantes={setShowParticipantes}
                        renderizar={renderizar}
                        volver={volver}
                        esMutuoNormalyConComplementario={props.esMutuoNormalyConComplementario}
                        isComplementario={props.isComplementario}
                        isDesactivado={props.isDesactivado}
                        esVigente={props.esVigente}
                    ></DeudorJuridicoForm>
                </Grid2>
            }

            {
                (rolParticipanteSeleccionado === enumTipoParticipanteConValores.Codeudor) &&
                !showParticipantes &&

                <Grid2>
                    <CodeudorForm dataCodeudor={dataCodeudor}
                        ciudadesSelect={ciudadesSelect}
                        estadoCivilSelect={estadoCivilSelect}
                        beneficioSiiSelect={beneficioSiiSelect}
                        idMutuo={props.idMutuo}
                        setShowParticipantes={setShowParticipantes}
                        renderizar={renderizar}
                        volver={volver}
                        esNuevo={participanteNuevo}
                        esJuridico={esJuridicio}
                        esConyuge={esConyuge}
                        handleDelete={handleDelete}
                        esMutuoNormalyConComplementario={props.esMutuoNormalyConComplementario}
                        isComplementario={props.isComplementario}
                        isDesactivado={props.isDesactivado}
                        esVigente={props.esVigente}
                        deudorEsBeneficiarioSii={!!dataDeudor?.beneficioSiiAsignado}
                    />
                </Grid2>
            }

            {
                (rolParticipanteSeleccionado === enumTipoParticipanteConValores.Mandatario) &&
                !showParticipantes &&

                <Grid2>
                    <MandatarioForm dataMandatario={dataMandatario}
                        ciudadesSelect={ciudadesSelect}
                        estadoCivilSelect={estadoCivilSelect}
                        idMutuo={props.idMutuo}
                        setShowParticipantes={setShowParticipantes}
                        esParticipanteNuevo={participanteNuevo}
                        renderizar={renderizar}
                        volver={volver}
                        handleDelete={handleDelete}
                        esMutuoNormalyConComplementario={props.esMutuoNormalyConComplementario}
                        isComplementario={props.isComplementario}
                        isDesactivado={props.isDesactivado}
                        esVigente={props.esVigente}
                    />
                </Grid2>
            }

            {
                (rolParticipanteSeleccionado === enumTipoParticipanteConValores.Conyuge) &&
                !showParticipantes &&

                <Grid2>
                    <ConyugeForm dataConyuge={dataConyuge}
                        ciudadesSelect={ciudadesSelect}
                        estadoCivilSelect={estadoCivilSelect}
                        idMutuo={props.idMutuo}
                        setShowParticipantes={setShowParticipantes}
                        renderizar={renderizar}
                        volver={volver}
                        esNuevo={participanteNuevo}
                        participantes={listaParticipantes}
                        handleDelete={handleDelete}
                        esMutuoNormalyConComplementario={props.esMutuoNormalyConComplementario}
                        isComplementario={props.isComplementario}
                        isDesactivado={props.isDesactivado}
                        esVigente={props.esVigente}
                    />
                </Grid2>
            }
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
        </>
    );
};

export default ListaParticipantes;


